module.exports = __webpack_public_path__ + "img/av104.1724bc80.png";